module.exports = __webpack_public_path__ + "assets/img/Employment-Inovations-Landing-Page-w540.043dea9a.webp";